module.exports = __webpack_public_path__ + "img/turntableBg.876b2044.png";